<template>
  <div v-swiper:FiberSlider="settings">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <div class="relative text-center top-0 lg:hidden fibre-pagination swiper-pagination"></div>
  </div>
</template>
<script>
export default {
  name: 'FiberSlider',
  data () {
    return {
      settings: {
        slidesPerView: 1,
        direction: "horizontal",
        loop: false,
        spaceBetween: 40,
        noSwiping: false,
        pagination: {
          clickable: true,
          el: '.fibre-pagination',
        },
        allowTouchMove: true,
        breakpoints: {
          650: {
            slidesPerView: 3,
            spaceBetween: 20,
            noSwiping: false,
            allowTouchMove: true,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
            noSwiping: true,
            allowTouchMove: false,
          }
        }
      }
    }
  }
}
</script>
